import React, { useState } from 'react';
import { FormProvider, useForm } from 'react-hook-form';

import { Radio } from '@ast/magma/components/radio';

import { uniqueId } from '@ast/magma/inner/utils/uniqueid';

import styles from '@app/common/components/UserSelectorDialog/UserSelectorForm/UserSelectorForm.pcss';
import { UserOption } from '@app/common/types/UserOption';

export interface UserSelectorFormProps<User extends UserOption> {
  // eslint-disable-next-line i18next/no-literal-string
  readonly 'data-stable-name': string;
  readonly userOptions: User[];
  readonly currentUser: User;
  readonly onSubmit: (selectedUser: User) => void;
  readonly formId: string;
}

const RADIO_GROUP_NAME = 'selectedUser';

export const UserSelectorForm = <User extends UserOption>({
  // eslint-disable-next-line i18next/no-literal-string
  'data-stable-name': dataStableName,
  userOptions,
  currentUser,
  formId,
  onSubmit,
}: UserSelectorFormProps<User>) => {
  const [selectedUserId, setSelectedUserId] = useState(currentUser.id);
  const form = useForm({
    mode: 'onSubmit',
  });
  const submitHandler = () => {
    const selectedUser = userOptions.find((p) => p.id === selectedUserId);
    if (selectedUser) onSubmit(selectedUser);
  };

  return (
    <FormProvider {...form}>
      <form
        id={formId}
        onSubmit={form.handleSubmit(submitHandler)}
        data-stable-name={dataStableName}
      >
        {
          userOptions.map((option) => {
            const loginId = uniqueId('user-option-login');
            return (
              <div
                className={styles.userOption}
                key={option.id}
              >
                <Radio
                  label={`${option.userDisplayName}`}
                  value={option.id}
                  name={RADIO_GROUP_NAME}
                  checked={selectedUserId === option.id}
                  onChange={() => setSelectedUserId(option.id)}
                  aria-describedby={loginId}
                />
                <span id={loginId} className={styles.businessName}>{option.userLogin}</span>
              </div>
            );
          })
        }
      </form>
    </FormProvider>
  );
};
